import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function Phone_Number_SignUp() {
  const [phone, setPhone] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <>
      {/* Email */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/phone.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
         Email
        </Form.Label>

         <Form.Control
        type="email"
            placeholder="Please enter the Email"
          />
      </div>

      {/* Set Password */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/lock.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Set Password
        </Form.Label>

        <div className="password_input">
          <Form.Control
            type={showPassword ? "text" : "password"}
            placeholder="Set Password"
          />
          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>
      </div>

      {/* Confirm Password */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/lock.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Confirm Password
        </Form.Label>

        <div className="password_input">
          <Form.Control
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm Password"
          />
          <span
            className="eye-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>
      </div>

      {/* Invite Code */}
      <div className="form-group field_holder invite_code_wrapper">
        <Form.Label>
          <img
            src="/assets/images/icons/sheild.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Invite Code
        </Form.Label>

        <div className="invite_input">
          <Form.Control
            type="text"
            placeholder="Please Enter the Invitation Code"
          />
          <Button className="send_btn">Send</Button>
        </div>
      </div>

     
    </>
  );
}

export default Phone_Number_SignUp;
